import React, { useState } from 'react';
import { Steps, Card } from 'antd';
import { AccessLevel, RowLevelAction, StepAction, StepDetailProps } from '../../types/types';
import ViewSingleBlueprintForm from '../../components/viewRecord/viewSingleBlueprintForm';

interface Props {
  stepFlowProps: StepDetailProps;
  urlparams: Map<string, string>;
  open: boolean;
  platformAction: RowLevelAction;
  setOpen: (value: boolean) => void;
  isCreateFlow?: boolean;
  isRelatedInfo?: boolean;
  userAccessLevel: AccessLevel;
  recordIds?: any[];
  loanNos?: any[];
  customerNames?: any[];
  refreshTable: Function;
  allowEdits?: boolean;
  selectedRows?: any[];
  // prefillColumns?: string[];
  moduleCode: string;
  renderCustomDetailPage?: Function;
}

const { Step } = Steps;

const CustomSteps: React.FC<Props> = ({
  stepFlowProps,
  urlparams,
  open,
  setOpen,
  isCreateFlow,
  isRelatedInfo,
  userAccessLevel,
  platformAction,
  recordIds,
  loanNos,
  customerNames,
  refreshTable,
  allowEdits,
  selectedRows,
  // prefillColumns,
  moduleCode,
  renderCustomDetailPage,
}) => {

  const [current, setCurrent] = useState<number>(0);

  const setOpenWrapper = (input: boolean) => {
    if(current === steps.length - 1){
      setOpen(false);
    }
  }

  const  onStepAction = (action: StepAction) => {
    if(action === StepAction.BACK){
      prev();
    }else if(action === StepAction.NEXT){
      next();
    }
  }

  const steps = stepFlowProps.screens.map((screen, index) => {

    return {
      title: screen.title ?? "",
      content: <ViewSingleBlueprintForm
        enableStepNext={index< stepFlowProps.screens.length-1}
        enableStepSubmit={index === stepFlowProps.screens.length-1}
        enableStepBack={index>0}
        onStepAction={onStepAction}
        isCreateFlow={isCreateFlow}
        isRelatedInfo={isRelatedInfo}
        open={open}
        renderCustomDetailPage={renderCustomDetailPage}
        urlparams={urlparams}
        setOpen={setOpenWrapper}
        userAccessLevel={userAccessLevel}
        platformAction={platformAction}
        blueprintApi={screen.blueprintApi ?? ""}
        recordIds={recordIds}
        loanNos={loanNos}
        customerNames={customerNames}
        refreshTable={refreshTable}
        allowEdits={allowEdits ?? true}
        selectedRows={selectedRows}
        // prefillColumns={prefillColumns}
        moduleCode={moduleCode}
        title={screen.title ?? ""}
      />
    }
  });

  const next = () => {
    setCurrent(current + 1);
  }

  const prev = () => {
    setCurrent(current - 1);
  }

  return (
    <div>
      <Card>
        <Steps current={current}>
          {steps.map(item => (
            <Step key={item.title} title={item.title} />
          ))}
        </Steps>
        <div className="steps-content">{steps[current].content}</div>
        {/* <div className="steps-action">
          {current < steps.length - 1 && (
            <Button type="primary" onClick={() => next()}>
              Save & Continue
            </Button>
          )}
          {current === steps.length - 1 && (
            <Button type="primary" onClick={() => message.success('Processing complete!')}>
              Submit
            </Button>
          )}
          {current > 0 && (
            <Button style={{ marginLeft: 8 }} onClick={() => prev()}>
              Back
            </Button>
          )}
        </div> */}
      </Card>
    </div>
  );
}


export default CustomSteps;